import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { ionBreakpointMd } from "../../theme/breakpoints.const";
import { Role } from "src/services/user/role.enum";
import { AuthService } from "src/services/auth/auth.service";
import { customerPages } from "src/services/navigation/paths.const";
import { isInKioskMode } from "src/services/utils/kiosk-mode.utils";

export const RedirectToDownloadAppOnDesktopGuard = async (): Promise<boolean> => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (isInKioskMode()) {
    return true;
  }

  await authService.waitForAuthInit();

  const currentUser = await authService.getActiveUser();

  if (currentUser?.role === Role.admin || currentUser?.role === Role.driver) {
    return true;
  }

  if (window.innerWidth > ionBreakpointMd) {
    await router.navigate([customerPages.downloadTheApp]);
    return false;
  }

  return true;
};
